import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import Text from 'components/shared/Text'
import { Wrapper as Icon } from 'components/shared/Icon/styles'
import Info from 'components/shared/Info'
import palmDecor from 'assets/images/decors/info/palm.svg'

export const StyledInfo = styled(Info)`
    width: 100%;
    flex-direction: column;
    padding: 16px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.darkmode_900};
    background-image: url(${palmDecor});
    background-position: 100% 100%;
    background-repeat: no-repeat;

    @media ${respondAbove.xl} {
        flex-direction: row;
        padding: 24px;
    }

    ${Icon} {
        margin-bottom: 8px;

        @media ${respondAbove.xl} {
            margin-bottom: 0;
        }
    }
    & > ${Text} {
        margin-right: 12px;
        color: ${({ theme }) => theme.colors.grayscale_300};

        @media ${respondAbove.xl} {
            margin-right: 0;
        }

        span {
            color: ${({ theme }) => theme.colors.grayscale_300};
        }
        strong {
            color: ${({ theme }) => theme.colors.primary_500};
        }
    }
    a {
        display: block;

        @media ${respondAbove.xl} {
            display: inline;
        }
    }
`
